import {
    get,
    put,
     post,
     del
  } from '../configApi'
  export async function fetchMenuCompany(body) {
    return await get(`/company/setting/list/admin`,body)
  }
  export async function insertMenuCompany(body) {
    return await post(`/company/setting/manage/insert`, body)
  }
  export async function updateMenuCompany(body) {
    return await put(`/company/setting/manage/update`, body)
  }
  export async function deleteMenuCompany(body) {
    return await del(`/company/setting/manage/delete`, body)
  }
  export async function activeMenuCompany(body) {
    return await put(`/company/setting/manage/active`, body)
  }
  export async function setPiorityMenu(body) {
    return await put(`/company/setting/manage/setpriority`, body)
  }
  export async function setPiorityElement(body) {
    return await put(`/company/setting/manage/setpriorityelement`, body)
  }
